import React from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  Table,
  TableRow,
  Td,
  Th,
  THead
} from '@increasecard/typed-components';
import { TFunction } from 'i18next';

interface FilesFormatModalProps {
  showModal: boolean;
  toggleShowFilesFormatModal: () => void;
  translationFunction: TFunction;
}

const FilesFormatModal = ({
  showModal,
  toggleShowFilesFormatModal,
  translationFunction
}: FilesFormatModalProps) => (
  <Modal
    onCancel={toggleShowFilesFormatModal}
    onClose={toggleShowFilesFormatModal}
    onOk={toggleShowFilesFormatModal}
    visible={showModal}
    width="580"
  >
    <ModalHeader>{translationFunction('clearings:uploadScreen:modal:title')}</ModalHeader>
    <ModalContent>
      <Table zebra>
        <THead>
          <tr>
            <Th>
              {translationFunction('clearings:uploadScreen:modal:table:headers:infoProvider')}
            </Th>
            <Th>
              {translationFunction('clearings:uploadScreen:modal:table:headers:documentType')}
            </Th>
            <Th>{translationFunction('clearings:uploadScreen:modal:table:headers:format')}</Th>
          </tr>
        </THead>
        <tbody>
          <TableRow double>
            <Td>
              {translationFunction(
                'clearings:uploadScreen:modal:table:fields:interdin:infoProvider'
              )}
            </Td>
            <Td>
              {translationFunction(
                'clearings:uploadScreen:modal:table:fields:interdin:documentType'
              )}
            </Td>
            <Td>
              {translationFunction('clearings:uploadScreen:modal:table:fields:interdin:format')}
            </Td>
          </TableRow>
          <TableRow double>
            <Td>
              {translationFunction(
                'clearings:uploadScreen:modal:table:fields:pacific:infoProvider'
              )}
            </Td>
            <Td>
              {translationFunction(
                'clearings:uploadScreen:modal:table:fields:pacific:documentType'
              )}
            </Td>
            <Td>
              {translationFunction('clearings:uploadScreen:modal:table:fields:pacific:format')}
            </Td>
          </TableRow>
          <TableRow double>
            <Td>
              {translationFunction(
                'clearings:uploadScreen:modal:table:fields:guayaquil:infoProvider'
              )}
            </Td>
            <Td>
              {translationFunction(
                'clearings:uploadScreen:modal:table:fields:guayaquil:documentType'
              )}
            </Td>
            <Td>
              {translationFunction('clearings:uploadScreen:modal:table:fields:guayaquil:format')}
            </Td>
          </TableRow>
        </tbody>
      </Table>
    </ModalContent>
  </Modal>
);

export default FilesFormatModal;
